<template>
  <div class="ai-mentor-report reset-scrollbar">
    <pc-navbar />
    <div class="head">
      <h1>简历评分与分析专家报告</h1>
      <p>专业分析您的简历与目标职位的匹配度，提供针对性的改进建议</p>
    </div>
    
    <img class="head-bg1" src="https://files.wondercv.com/ai-mentor/report/bg-icon1.png" />
    <img class="head-bg2" src="https://files.wondercv.com/ai-mentor/report/bg-icon1.png" />

    <template v-if="reportData">
      <!-- 简历概述 -->
      <section class="current-resume-overview">
        <h2 class="section-title">
          <img src="https://files.wondercv.com/ai-mentor/report/title-1.png" class="icon"/>
          <span>当前简历概述</span>
        </h2>
        <div class="score-cards">
          <div class="score-card" v-for="(item, index) in resumeScoreOptions" :key="index" :class="{ active: resumeScoreActive === index }" @mousemove="resumeScoreActive = index">
            <div class="label">{{ item.title }}</div>
            <div class="score">
              <Progress
                :size="132"
                :strokeWidth="8"
                :percentage="item.score"
                class="gradient-circle"
              />
              <span class="score-number">{{item.score}}</span>
            </div>
            <!-- <div class="percentage">超过 {{ item.percentage }}% 的申请者</div> -->
          </div>
        </div>

        <div class="feedback-card" v-if="reportData.overall_assessment.summary_comments">
          <img src="https://files.wondercv.com/ai-mentor/report/quotation-marks.png" />
          <p class="text">
            {{reportData.overall_assessment.summary_comments || ''}}
          </p>
        </div>
      </section>

      <!-- 修改后简历 -->
      <section class="editor-resume">
        <h2 class="section-title">
          <img src="https://files.wondercv.com/ai-mentor/report/title-2.png" class="icon"/>
          <span>简历对比</span>
        </h2>
        <div class="resume-comparison">
          <div class="resume-view">
            <div class="title">
              <span>修改后简历</span>
            </div>
            <div class="view">
              <a :href="`/cvs/${newCvToken}/editor`" target="blank">
                <img :src="newResumeImg" class="resume-img" />
              </a>
            </div>
          </div>
          <div class="resume-view before-resume">
            <div class="title ">
              <span>修改前简历</span>
            </div>
            <div class="view">
              <a :href="`/cvs/${cv_token}/editor`" target="blank">
                <img :src="resumeImg" class="resume-img" />
              </a>
            </div>
          </div>
        </div>
      </section>

      <!-- 职位匹配分析 -->
      <section class="job-analysis">
        <h2 class="section-title">
          <span class="number">01</span>
          <div class="label">
            <img src="https://files.wondercv.com/ai-mentor/report/title-3.png" class="icon"/>
            <span>职位匹配分析</span>
          </div>
        </h2>
        <div class="section-content job-analysis-content">
          <div class="analysis-item">
            <div class="section-item-header">
              <img src="https://files.wondercv.com/ai-mentor/report/job-1.png" class="icon"/>
              <div class="label">硬性要求</div>
            </div>
            <div class="condition-items">
              <div class="item" v-for="(item, index) in reportData.job_match_analysis.hard_requirements" :key="index">
                <div class="tag tag-satisfy" v-if="item.satisfied">
                  <span class="iconfont iconxuanzhong"></span>
                  <span class="text">满足需求</span>
                </div>
                <div class="tag tag-not-meet" v-else>
                  <span class="iconfont iconcha"></span>
                  <span class="text">未满足</span>
                </div>
                <div class="condition">
                  <div class="label">{{item.requirement}}</div>
                  <div class="desc" v-if="!item.satisfied && item.evidence">
                    <p>{{item.evidence}}</p>
                  </div>
                </div>
              </div>
              <!-- <div class="tag tag-partially-meet">
                  <span class="iconfont icontanhao"></span>
                  <span class="text">部分满足</span>
                </div>

                <div class="tag tag-not-meet">
                  <span class="iconfont iconcha"></span>
                  <span class="text">未满足</span>
                </div> -->
            </div>
          </div>
          <div class="analysis-item">
            <div class="section-item-header">
              <img src="https://files.wondercv.com/ai-mentor/report/job-2.png" class="icon"/>
              <div class="label">技能要求</div>
            </div>
            <div class="condition-items">
              <div class="item" v-for="(item, index) in reportData.job_match_analysis.skill_requirements" :key="index">
                <div class="tag tag-satisfy" v-if="item.satisfied">
                  <span class="iconfont iconxuanzhong"></span>
                  <span class="text">满足需求</span>
                </div>
                <div class="tag tag-not-meet" v-else>
                  <span class="iconfont iconcha"></span>
                  <span class="text">未满足</span>
                </div>
                <div class="condition">
                  <div class="label">{{item.skill}}</div>
                  <div class="desc" v-if="!item.satisfied">
                    <p>问题：{{item.evidence_experience}}</p>
                    <p v-if="item.optimization_suggestion">改进建议：{{item.optimization_suggestion}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 竞争力分析 -->
      <section class="advantages-analysis">
        <h2 class="section-title">
          <span class="number">02</span>
          <div class="label">
            <img src="https://files.wondercv.com/ai-mentor/report/title-4.png" class="icon"/>
            <span>竞争力分析</span>
          </div>
        </h2>
        <div class="section-content advantages-analysis-content">
          <div class="analysis-item">
            <div class="section-item-header">
              <img src="https://files.wondercv.com/ai-mentor/report/advantages-1.png" class="icon"/>
              <div class="label">竞争者画像</div>
            </div>
            <div class="portrait-condition" v-if="reportData.competitiveness_analysis.competitor_profile">
              <img src="https://files.wondercv.com/ai-mentor/report/quotation-marks.png" class="icon"/>
              <div class="desc">{{reportData.competitiveness_analysis.competitor_profile || '-'}}</div>
            </div>
          </div>
          <div class="analysis-item">
            <div class="section-item-header">
              <img src="https://files.wondercv.com/ai-mentor/report/advantages-2.png" class="icon"/>
              <div class="label">比较分析</div>
            </div>
            <div class="contrast-condition" v-for="(item, index) in reportData.competitiveness_analysis.comparative_analysis" :key="index">
              <div class="label">{{item.aspect}}</div>
              <div class="analysis-label">
                <div class="shortcoming">优势：{{item.strength}}</div>
              </div>
              <div class="analysis-label">
                <div class="advantage" v-if="item.weakness">劣势：{{item.weakness}}</div>
              </div>
              <div class="desc" v-if="item.improvement_suggestion">{{item.improvement_suggestion}}</div>
            </div>
          </div>
          <div class="analysis-item" >
            <div class="section-item-header">
              <img src="https://files.wondercv.com/ai-mentor/report/advantages-3.png" class="icon"/>
              <div class="label">差异化策略</div>
            </div>
            <div class="portrait-condition">
              <img src="https://files.wondercv.com/ai-mentor/report/quotation-marks.png" class="icon"/>
              <div class="desc">{{reportData.competitiveness_analysis.differentiation_strategy || '-'}}</div>
            </div>
          </div>
        </div>
      </section>


      <!-- 简历结构分析 -->
      <section class="structure-analysis">
        <h2 class="section-title">
          <span class="number">03</span>
          <div class="label">
            <img src="https://files.wondercv.com/ai-mentor/report/title-5.png" class="icon"/>
            <span>简历结构分析</span>
          </div>
        </h2>
        <div class="section-content">
          <div class="analysis-item" style="margin-bottom: 48px;"
            v-if="reportData.resume_structure_analysis.structure_issues && reportData.resume_structure_analysis.structure_issues.length">
            <div class="section-item-header">
              <img src="https://files.wondercv.com/ai-mentor/report/structure-1.png" class="icon"/>
              <div class="label">结构问题</div>
            </div>
            <div class="structure-question">
              <div class="item" v-for="(item, index) in reportData.resume_structure_analysis.structure_issues" :key="index">
                <div class="title">{{item.issue}}</div>
                <div class="question">
                  <div class="label">改进建议：</div>
                  <div class="desc">{{item.optimization_suggestion}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="analysis-item" v-if="reportData.resume_structure_analysis.ideal_structure">
            <div class="section-item-header">
              <img src="https://files.wondercv.com/ai-mentor/report/structure-2.png" class="icon"/>
              <div class="label">理想结构建议</div>
            </div>
            <div class="structure-suggestion">
              <img src="https://files.wondercv.com/ai-mentor/report/quotation-marks.png" class="icon">
              <div class="desc">{{reportData.resume_structure_analysis.ideal_structure || '-'}}</div>
            </div>
          </div>
        </div>

      </section>

      <!-- 经验内容分析 -->
      <section class="content-analysis">
        <h2 class="section-title">
          <span class="number">04</span>
          <div class="label">
            <img src="https://files.wondercv.com/ai-mentor/report/title-6.png" class="icon"/>
            <span>经验内容分析</span>
          </div>
        </h2>
        <div class="section-content" v-for="(item, index) in reportData.experience_analysis" :key="index">
          <div class="analysis-item">
            <div class="section-item-header">
              <div class="label">{{item.experience_section}}</div>
            </div>
            <div class="question-content" v-for="(sitem, sindex) in item.content_analysis.filter(sitem => !!sitem.improved_example)" :key="sindex">
              <div class="title">问题{{sindex+1}}：{{sitem.issue}}</div>
              <div class="contrast">
                <div class="content wrong">
                  <div class="label">
                    <div class="iconfont iconcha"></div>
                    <div class="text">当前文本</div>
                  </div>
                  <div class="desc">"{{sitem.current_text}}"</div>
                </div>
                <div class="icon">
                  <span class="iconfont icontiaozhuan"></span>
                </div>
                <div class="content worrect">
                  <div class="label">
                    <div class="iconfont iconxuanzhong"></div>
                    <div class="text">改后文本</div>
                  </div>
                  <div class="desc">"{{sitem.improved_example}}"</div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 潜在面试问题 -->
      <section class="nterview-questions">
        <h2 class="section-title">
          <span class="number">05</span>
          <div class="label">
            <img src="https://files.wondercv.com/ai-mentor/report/title-7.png" class="icon"/>
            <span>潜在面试问题</span>
          </div>
        </h2>
        <div class="section-content" v-for="(item, index) in reportData.potential_interview_questions" :key="index">
          <div class="ai-question">
            <img src="https://files.wondercv.com/ai-mentor/report/nterview-1.png" class="icon"/>
            <div class="message">
              <div class="title">
                <div class="tag tag-satisfy" v-if="item.risk_level == '低'">
                  <span class="iconfont icontanhao"></span>
                  <span class="text">低风险</span>
                </div>
                <div class="tag tag-partially-meet" v-else-if="item.risk_level == '中'">
                  <span class="iconfont icontanhao"></span>
                  <span class="text">中风险</span>
                </div>
                <div class="tag tag-not-meet" v-else-if="item.risk_level == '高'">
                  <span class="iconfont icontanhao"></span>
                  <span class="text">高风险</span>
                </div>
                <div class="label">{{item.question}}</div>
              </div>
              <div class="desc">
                <p>{{item.concern}}</p>
              </div>
            </div>
          </div>
          <div class="suggestion">
            <div class="title">建议回应</div>
            <div class="desc">{{item.recommended_response}}</div>
          </div>
        </div>
        
      </section>

      <div class="footer-action">
        <div class="download" @click="viewResume">立即编辑简历</div>
      </div>

    </template>

  </div>
</template>

<script>
import api from "@/api/index";

// components
import PcNavbar from "@/components/base/navbar";
import Progress from "./progress";

export default {
  name: 'AiMentorReport',
  data() {
    return {
      // resumeScoreOptions:[{
      //   title: "总体分数",
      //   score: 25,
      //   percentage: 72
      // }, {
      //   title: "竞争力评分",
      //   score: 85,
      //   percentage: 72
      // }, {
      //   title: "职位匹配度",
      //   score: 85,
      //   percentage: 72
      // }, {
      //   title: "简历表达质量",
      //   score: 85,
      //   percentage: 72
      // }],
      cv_token: '',
      newCvToken: '',

      resumeScoreActive: 0,

      reportData: null,

      resumeImg: '',
      newResumeImg: '',
      
    };
  },
  computed: {
    resumeScoreOptions(){
      let overall_assessment = this.reportData && this.reportData?.overall_assessment ? this.reportData?.overall_assessment : {};
      return [{
        title: "总体分数",
        score: overall_assessment.total_score,
        percentage: 72
      }, {
        title: "竞争力评分",
        score: overall_assessment.competitiveness_score,
        percentage: 72
      }, {
        title: "职位匹配度",
        score: overall_assessment.job_match_score,
        percentage: 72
      }, {
        title: "简历表达质量",
        score: overall_assessment.resume_expression_score,
        percentage: 72
      }]
    },
  },
  components: {
    PcNavbar,
    Progress
  },
  created() {
    let { cv_token } = this.$route.params
    this.cv_token = cv_token
    this.getReportData();
    // 获取简历图片
    this.getResumeImg({
      type: 'resumeImg',
      token: cv_token
    });
  },
  mounted() {
    
  },
  methods: {
    getReportData() {
      api.AI.getAiMentorReport({
        cv_token: this.cv_token
      }).then(res => {
        if (res.code == 1000) {
          let { report_generation, cv_optimization={} } = res.data;
          this.reportData = report_generation;
          console.log(this.reportData);

          // 保存新简历token
          this.newCvToken = cv_optimization.new_cv_token;
          // 获取简历图片
          this.getResumeImg({
            type: 'newResumeImg',
            token: cv_optimization.new_cv_token
          });
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        console.log(err);
      });
    },
    viewResume(){
      window.open(`/cvs/${this.newCvToken}/editor`)
    },

    // 获取简历图片
    getResumeImg(options){
      let { type, token } = options;
      api.cvsV3.getCvImgDownloadUrl(token).then(res => {
        if(res.code === 1000 && res.data.url){
          this[type] = res.data.url
        }
      })
    },
  }
};
</script>

<style scoped lang="scss">
// @import "@/assets/styles/variables.scss";
@import "./report.scss";
</style>